import {
    type ViewStyle,
    StyleSheet
} from "react-native";

export const SIDEBAR_GROUP_LABEL_VARIANT: keyof NCoreUIKit.Typography = "labelSmallSize";

const stylesheet = StyleSheet.create({
    container: {
        flexDirection: "row",
        alignItems: "center"
    },
    hiddenTitle: {
        position: "absolute",
        overflow: "hidden",
        opacity: 0
    },
    separator: {
        alignSelf: "center"
    },
    title: {
        flexShrink: 1,
        flexGrow: 1
    }
});

export const useStyles = ({
    controlHeights,
    isCollapsed,
    borders,
    colors,
    spaces
}: {
    colors: NCoreUIKit.ActivePalette["colors"];
    spaces: NCoreUIKit.ActivePalette["spaces"];
    controlHeights: NCoreUIKit.ControlHeights;
    borders: NCoreUIKit.Borders;
    isCollapsed: boolean;
}) => {
    return {
        separator: {
            backgroundColor: colors.content.border.subtle,
            height: borders.separator,
            width: spaces.spacingLg
        } as ViewStyle,
        container: (isCollapsed ? {
            height: borders.separator
        } : {
            paddingStart: spaces.spacingSm,
            height: controlHeights.small
        }) as ViewStyle,
        hiddenTitle: {
            height: borders.separator,
            width: borders.separator
        } as ViewStyle
    };
};
export default stylesheet;
